import { MainFooter } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import React from 'react';
import './cspFooter.scss';
import PropTypes from 'prop-types';

import { CustomerFooter } from './customFooter';

const CspFooter = ({ termsUrlByBrand, logo }) => {
  const customFooter = {
    customContent: (
      <CustomerFooter
        termsUrlByBrand={termsUrlByBrand}
        logo={logo}
      />
    ),
    customDisclosure: null,
    socialLinks: null
  };
  return <MainFooter {...customFooter} />;
};

export default CspFooter;

CspFooter.propTypes = {
  termsUrlByBrand: PropTypes.string,
  logo: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageTitle: PropTypes.string,
    imageTitleDescription: PropTypes.string
  })
};
